import { render, staticRenderFns } from "./MarkdownText.vue?vue&type=template&id=5f5e98a4&"
import script from "./MarkdownText.vue?vue&type=script&lang=js&"
export * from "./MarkdownText.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports